import {ProjectClassification, ProjectStatus} from '../../enums';
import {IProject, Member, ProjectMember} from './project';
import {IProjectInfo} from './project-info';
import {ProjectDetailsData} from './project-data';
import {IUserIdentity} from '../user/user';
import {ProjectAttributes} from "./project-attribute";

export class ProjectAnalysisAnswer {
     answerAsBool?: object;
     answerAsText?: string;
     answerAsInteger?: object;
     answerAsPercentage?: number;
     answerAsDate?: Date;
     multipleChoiceAnswer?: string;
     explanation?: string;
     pitTag: string;
}

export interface ProjectPhoto {
    id?:               string;
    imageBase64?:      string;
    isPrimary?:        string;
    contentType?:      string;
    originalFileName?: string;
}


export class ProjectDetails implements IProject {
    id: number;
    name: string;
    owner: IUserIdentity;
    riskManager: IUserIdentity;
    newRiskManager: IUserIdentity;
    newOwner: IUserIdentity;
    description: string;
    status: ProjectStatus;
    statusBeforeOnHold: ProjectStatus;
    modifiedAt: Date;
    pitReadyAt: Date;
    classification: ProjectClassification;
    tisClassification: ProjectClassification;
    tisClassificationOutdated: boolean;
    address: string;
    city: string;
    country: string;
    company: string;
    companyId: number;
    companyTypeId: number;
    quickscanDefinitionVersionId: number;
    tisDefinitionVersionId: number;
    thumbnailBase64: string;
    evaluation: string;
    statementFromUser: string;
    projectInfo: IProjectInfo;
    durationInMonths: number;
    riskAssessmentDescription: string;
    members: ProjectMember[];
    companyMembers: Member[];
    tisLabelShort: string;
    projectAnalysisAnswers: ProjectAnalysisAnswer[];
    projectAttributes: ProjectAttributes;

    constructor(data: ProjectDetailsData) {
        this.id = data.id;
        this.name = data.name;
        this.owner = data.owner;
        this.newOwner = data.owner;
        this.riskManager = data.riskManager;
        this.newRiskManager = data.riskManager;
        this.status = data.status;
        this.statusBeforeOnHold = data.statusBeforeOnHold;
        this.modifiedAt = new Date(data.modifiedAt);
        this.description = data.description;
        this.classification = data.classification;
        this.tisClassification = data.tisClassification;
        this.tisClassificationOutdated = data.tisClassificationOutdated;
        this.tisLabelShort = data.tisLabelShort;
        this.address = data.address;
        this.city = data.city;
        this.country = data.country;
        this.company = data.company;
        this.companyId = data.companyId;
        this.companyTypeId = data.companyTypeId;
        this.projectInfo = data.projectInfo;
        this.quickscanDefinitionVersionId = data.quickscanDefinitionVersionId;
        this.tisDefinitionVersionId = data.tisDefinitionVersionId;
        this.evaluation = data.evaluation;
        this.statementFromUser = data.statementFromUser;
        this.durationInMonths = data.durationInMonths;
        this.riskAssessmentDescription = data.riskAssessmentDescription;
        this.members = data.members ? data.members.map((member) => new ProjectMember(member)) : [];
        this.companyMembers = data.companyMembers ? data.companyMembers.map((member) => new Member(member)) : [];
        this.projectAnalysisAnswers = data.projectAnalysisAnswers ?? [];
        this.pitReadyAt = data.pitReadyAt;
        this.projectAttributes = data.projectAttributes;
    }

    public isMandated(): boolean {
        switch (this.status) {
            case ProjectStatus.MANDATING:
            case ProjectStatus.MANDATING_SUCCEEDED:
            case ProjectStatus.IN_EXECUTION:
                return true;
            default:
                return false;
        }
    }

    public isOnHold(): boolean {
        return (this.status === ProjectStatus.ON_HOLD);
    }

    public isInMandateProcess(): boolean {
        return (this.status === ProjectStatus.MANDATING);
    }

    public isClosed(): boolean {
        return (this.status === ProjectStatus.CLOSED);
    }

    public hasAttachmentsForTis(): boolean {
        return false;
    }
}
